<ng-container *ngIf="count <= nzOverflowCount; else overflowTemplate">
  <span *ngFor="let n of maxNumberArray; let i = index" class="ant-scroll-number-only" [style.transform]="'translateY(' + -countArray[i] * 100 + '%)'">
    <ng-container *ngIf="!nzDot && countArray[i] !== undefined">
      <p *ngFor="let p of countSingleArray" class="ant-scroll-number-only-unit" [class.current]="p === countArray[i]">
        {{ p }}
      </p>
    </ng-container>
  </span>
</ng-container>
<ng-template #overflowTemplate>{{ nzOverflowCount }}+</ng-template>
